{
  "categories": {
    "certificates": "Certificats",
    "dashboard": "Dashboard",
    "dataTransfer": "Transfert de données",
    "other": "Autre",
    "products": "Produits",
    "suppliers": "Fournisseurs"
  },
  "title": "FAQ"
}
